namespace appn { 

    export enum GeoMapType {
        standard = 'Standard',
        satellite = 'Satellite',
        hybrid = 'Hybrid',
        custom = 'Custom'
    }

    export interface GeoPoint {
        Latitude: number;
        Longitude: number;
    }

    export interface GeoPosition extends GeoPoint {
        Altitude: number;
        Accuracy: number;
        Heading: number;
        Speed: number;
        Title: string;
        Subtitle: string;
        TimeStamp: string;
        TimeAgo: string;
    }
} 
